import script from "./HTSnakeGameSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./HTSnakeGameSetting.vue?vue&type=script&setup=true&lang=js"

import "./HTSnakeGameSetting.vue?vue&type=style&index=0&id=1646b87f&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1646b87f"]])

export default __exports__